const randomBetween = (min, max) => {
    // The maximum is inclusive and the minimum is inclusive
    return Math.floor(Math.random() * (max - min + 1) + min);
}

export default randomBetween;


// WEBPACK FOOTER //
// ./src/helpers/randomBetween.js